import axios from 'axios'

const AXHR = axios.create({
  withCredentials: true
})

export default AXHR